import { withTranslation } from "react-i18next";
import React, { useState, useEffect } from 'react';
import { LOADER_COLOR } from "../../core/constants/common";
import { ScaleLoader } from "react-spinners";
import { BsCameraFill, BsTrash } from "react-icons/bs";
import "./LogoUploadCard.scss";

const LogoUploadCard = ({ t, imgFile, name, onFileChange, onFileDelete }) => {

	const [loading, setLoading] = useState(false);

	return (
		<div className="logo-holder">
			<div className="logo-card">
				{imgFile && <img src={imgFile} alt={name} />}
				<div className="img-edit">
					<div>
						{loading && (
							<div className="loader-custom">
								<ScaleLoader color={LOADER_COLOR} loading={true} size={25} />
							</div>
						)}
						<input
							type="file"
							id="imageUpload"
							accept=".png, .jpg, .jpeg"
							onChange={(e) => onFileChange(e)}
							onClick={(e) => {
								e.target.value = null;
							}}
						/>
						{
							imgFile &&
							<label htmlFor="imageUpload">
								<BsCameraFill />
							</label>
						}
					</div>
					{
						imgFile &&
						<div className="mt-2">
							<span htmlFor="imageUpload">
								<BsTrash onClick={onFileDelete} />
							</span>
						</div>
					}
				</div>
			</div>
		</div>
	);
};

export default withTranslation()(LogoUploadCard);